import { createFileRoute, notFound } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { getVariant } from "@/tools/typing-speed-test/lib/variants";
import { VariantPage } from "@/tools/typing-speed-test/pages/VariantPage";

export const Route = createFileRoute("/typing-speed-test/$variant")({
  ssr: true,
  loader: ({ params }) => {
    if (!getVariant(params.variant)) throw notFound();
  },
  head: ({ params }) => {
    const variant = getVariant(params.variant);
    if (!variant) return {};
    return {
      meta: [
        { title: variant.metaTitle() },
        { name: "description", content: variant.metaDescription() },
        { property: "og:title", content: variant.metaTitle() },
        { property: "og:description", content: variant.metaDescription() },
        ...i18nOgMeta(variant.path),
      ],
      links: [...i18nLinks(variant.path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: m.typing_breadcrumb_home(),
                item: localeUrl(`/`),
              },
              {
                "@type": "ListItem",
                position: 2,
                name: m.typing_tool_name(),
                item: localeUrl(`/typing-speed-test`),
              },
              {
                "@type": "ListItem",
                position: 3,
                name: variant.navName(),
                item: localeUrl(`${variant.path}`),
              },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: variant.faqs.map((f) => ({
              "@type": "Question",
              name: f.q(),
              acceptedAnswer: { "@type": "Answer", text: f.a() },
            })),
          }),
        },
      ],
    };
  },
  component: VariantRoute,
});

function VariantRoute() {
  const { variant } = Route.useParams();
  const def = getVariant(variant);
  if (!def) return null;
  return <VariantPage variant={def} />;
}
